export default "__VITE_ASSET__D3mu2Qq2__"